import { useState } from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { Label } from './Label';
import { Check } from './Check';
import { Help } from './Help';
import { colors } from '../../constants';
import { SelectShared } from './SelectShared';

export const Select = ({ label, help, choices, value, onChange, noEmpty, emptyLabel }) => {
  if (!choices || choices.length == 0) return null;

  // const handleChoice = (v) => {
  //   setOpen(false);
  //   onChange(v);
  // }

  const pretty = (v) => {
    if (v == undefined) {
      return emptyLabel || ' ';
    }

    const m = choices.filter((choice) => choice[0] == v);
    const p = m.length && m[0].length ? m[0][1] : v;
    if (typeof p == 'string') {
      return p;
    } else {
      return '' + p;
    }
  };

  // let nodes;
  // if (choices[0].name) {
  //   nodes = [];
  //   for (const group of choices) {
  //     const node = group.choices.map((choice, index) => (
  //       <option key={index} value={choice[0]}>
  //         {choice.length == 1 ? choice[0] : choice[1]}
  //       </option>
  //     ));
  //     nodes.push(
  //       <optgroup key={group.name} label={group.name}>
  //         {node}
  //       </optgroup>,
  //     );
  //   }
  // } else {
  //   nodes = choices.map((choice, index) => (
  //     <option key={index} value={choice[0]}>
  //       {choice.length == 1 ? choice[0] : choice[1]}
  //     </option>
  //   ));
  // }

  // if (!noEmpty) {
  //   nodes.unshift(
  //     <option key="null" value="">
  //       {emptyLabel}
  //     </option>
  //   );
  // }

  // const decode = (val) => {
  //   if (val == 'false') return false;
  //   if (val == 'true') return true;
  //   return val;
  // };

  const renderChoice = (choice, onClose) => {
    const handleChoice = (e) => {
      e.preventDefault();
      console.log('handleChoice', choice);
      onChange(choice[0]);
      onClose();
    };

    return (
      <div
        style={{
          whiteSpace: 'nowrap',
          borderx: '1px solid green',
          cursor: 'pointer',
          padding: '4px 0',
          fontSize: 14,
          ...(choice[0] == value ? { fontWeight: 'bold' } : {}),
        }}
        key={choice[0]}
        value={choice[0]}
        onClick={handleChoice}
      >
        {choice.length == 1 ? choice[0] : choice[1]}
      </div>
    );
  };

  const isGrouped = Boolean(choices[0].name);

  const selectorNode = ({ onClose }) => {
    let nodes;
    if (isGrouped) {
      nodes = [];
      for (const group of choices) {
        const node = group.choices.map((choice) => renderChoice(choice, onClose));
        nodes.push(
          <div key={group.name}>
            <div style={{ whiteSpace: 'nowrap', color: '#888' }}>
              <i>{group.name}</i>
            </div>
            <div style={{ marginLeft: 20 }}>{node}</div>
          </div>,
        );
      }
    } else {
      nodes = choices.map((choice) => renderChoice(choice, onClose));
    }

    if (!noEmpty) {
      const empty = emptyLabel || <span>&nbsp;</span>;
      nodes.unshift(renderChoice([undefined, empty], onClose));
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isGrouped ? 10 : null,
        }}
      >
        {nodes}
      </div>
    );
  };

  return <SelectShared display={pretty(value)} selector={selectorNode} label={label} help={help} />;

  // return (
  //   <div style={{ positionx: 'relative' }}>
  //     <div
  //       style={{
  //              ...style,
  //              display: 'inline-flex',
  //              alignItems: 'center',
  //              padding: '8px 10px',
  //              gap: 10,
  //              cursor: 'pointer',
  //              fontSize: 14,
  //              colorx: colors.gentleGray,
  //       }}
  //       onClick={() => setOpen(!open)}
  //     >
  //       <div style={{ display: 'inline-flex', gap: 5, whiteSpace: 'nowrap', minWidth: 100 }}>
  //         {pretty(value)}
  //       </div>
  //       <div style={{ display: 'inline-flex', alignItems: 'center', borderLeft: '1px solid #ccc', paddingLeft: 8 }}>
  //         <FaCaretDown />
  //       </div>

  //     </div>

  //     <div style={{ position: 'absolute', marginTop: 1, zIndex: 300 }}>
  //       {selectorNode}
  //     </div>
  //     {bgNode}
  //   </div>
  // );
};
